exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.margin_bottom_12[data-v-ff8c45c0]{\n  margin-bottom:12px;\n}\n.margin_bottom_8[data-v-ff8c45c0]{\n  margin-bottom:8px;\n}\n.margin_left_7[data-v-ff8c45c0]{\n  margin-left:7px;\n}\n.red[data-v-ff8c45c0]{\n  margin-bottom:10px;\n  color:#ff0000;\n  font-size:12px;\n}\n.flex-start[data-v-ff8c45c0]{\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -ms-flex-line-pack: center;\n      align-content: center;\n}\n", ""]);

// exports
